@use "../../sass/variables/colors";

.ux-radio-button-media-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;

  ux-radio-button .ux-radio-button-field__label-container {
    display: none;
  }

  ux-radio-button {
    border: 3px solid transparent;
    flex: 1;
  }

  .ux-radio-button-field--active {
    border: 3px solid colors.$color-green;
  }
}
